import { render, staticRenderFns } from "./Housing.vue?vue&type=template&id=0a68195d&"
import script from "./Housing.vue?vue&type=script&lang=js&"
export * from "./Housing.vue?vue&type=script&lang=js&"
import style0 from "./Housing.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports